module.exports = __webpack_public_path__ + "static/media/childrens_hospital_mural_concept_1_2003.a3672ef8.webp";